import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Moment from 'react-moment';
import PropTypes from 'prop-types';
import React from 'react';

import { absolute } from '../../../components/AnimatedRoutes';
import {
  createMfa,
  deleteMfa,
  getMfa,
  updateMfa,
  verifyMfa,
} from '../../../../../ducks/user/mfa';
import Button from '../../../components/Button';
import Content from '../../../components/Content';
import CreateGoogleModal from './CreateGoogleModal';
import CreateYubikey from './CreateYubikey';
import DeleteModal from './ConfirmModal';
import Header from '../../../components/Header';
import InfoBox from '../../../components/InfoBox';
import Loader from '../../../components/Loader';
import RenameModal from './RenameModal';
import Subheader from '../../../components/Subheader';
import connectionStyles from '../Connections/connections.scss';
// import dhid from '../../../../../dhid';
import settingStyles from '../settings.scss';

const propTypes = {
  list: ImmutablePropTypes.map,
  dispatch: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    stackPop: PropTypes.func.isRequired,
  }),
};

class Security extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: null,
      errors: null,
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getMfa());
  }

  onGoogleClick = () => {
    this.props.dispatch(createMfa({ type: 'google' })).then((data) => {
      this.setState({
        modal: 'google',
        id: data.data.id,
        errors: null,
      });
    });
  };

  onGoogleHotpClick = () => {
    this.props.dispatch(createMfa({ type: 'google_count' })).then((data) => {
      this.setState({
        modal: 'google_count',
        id: data.data.id,
        errors: null,
      });
    });
  };

  onYubikeyClick = () => {
    this.setState({
      modal: 'yubikey',
      errors: null,
    });
  };

  onRenameClick = (id) => () => {
    this.setState({
      modal: 'rename',
      id,
      errors: null,
    });
  };

  onDeleteClick = (id) => () => {
    this.setState({
      modal: 'delete',
      id,
      errors: null,
    });
  };

  onModalClose = () => {
    this.setState({
      modal: null,
    });
  };

  onVerify = (data, create) => {
    const method = create ? createMfa : verifyMfa;
    this.props
      .dispatch(method(data))
      .then(() => {
        this.setState({
          modal: null,
          id: null,
        });
      })
      .catch((err) => {
        this.setState({
          errors: {
            code: [err.message],
          },
        });
      });
  };

  onRename = (id, name) => {
    this.props
      .dispatch(updateMfa(id, { name }))
      .then(() => {
        this.setState({
          modal: null,
          id: null,
        });
      })
      .catch((err) => {
        this.setState({
          errors: {
            name: [err.message],
          },
        });
      });
  };

  onDelete = (id) => {
    this.props
      .dispatch(deleteMfa(id))
      .then(() => {
        this.setState({
          modal: null,
          id: null,
        });
      });
  };

  onInputChange = (event, id) => {
    this.setState({
      [id]: event.target.value,
    });
  }

  render() {
    const {
      loading,
      history,
      list,
    } = this.props;
    const {
      modal,
      id,
      errors,
    } = this.state;

    // const user2fa = Object.keys(dhid.getUser().access.permissions).length > 0 || list.size > 0;
    const user2fa = true;

    return (
      <>
        <Header onBack={() => history.stackPop()}>
          <FormattedMessage
            id="security.header"
            description="Header text of Account security header"
            defaultMessage="Account security"
          />
        </Header>
        <Content>
          <CreateGoogleModal
            show={modal === 'google'}
            secret={list.getIn([`${id}`, 'secret', 'secret'])}
            id={id}
            errors={errors}
            onVerifyClick={this.onVerify}
            onModalClose={this.onModalClose}
            totp
          />
          <CreateGoogleModal
            show={modal === 'google_count'}
            secret={list.getIn([`${id}`, 'secret', 'secret'])}
            id={id}
            errors={errors}
            onVerifyClick={this.onVerify}
            onModalClose={this.onModalClose}
            hotp
          />
          <CreateYubikey
            show={modal === 'yubikey'}
            id={id}
            errors={errors}
            onVerifyClick={this.onVerify}
            onModalClose={this.onModalClose}
          />
          <RenameModal
            show={modal === 'rename'}
            id={id}
            list={list}
            errors={errors}
            onRename={this.onRename}
            onModalClose={this.onModalClose}
          />
          <DeleteModal
            show={modal === 'delete'}
            id={id}
            onDelete={this.onDelete}
            onModalClose={this.onModalClose}
          />

          { user2fa && (
            <>
              <Subheader big>
                <FormattedMessage
                  id="security.2fa.subheader"
                  description="Sub header text for 2fa"
                  defaultMessage="2-factor authentication"
                />
              </Subheader>
              <InfoBox>
                <FormattedMessage
                  id="security.2fa.infobox"
                  description="2fa infobox text"
                  defaultMessage="Account security is important for everyone, and nobody wants their accounts or information being used without their permission. 2-Factor Authentication adds an extra layer of security, making it considerably more difficult to breach an account."
                />
              </InfoBox>

              <Subheader
                buttons={(
                  <Button onClick={this.onGoogleClick} outline>
                    Activate
                  </Button>
            )}
              >
                <FormattedMessage
                  id="security.2fa.google"
                  description="Sub header text for Google Authenticator"
                  defaultMessage="Google Authenticator - Time-based One-Time Password (TOTP)"
                />
              </Subheader>
              <div className={settingStyles.panel}>
                <Loader loading={loading && list.size === 0} />
                <table className={connectionStyles.connections}>
                  <tbody>
                    {list
                      .sort((a, b) => a.get('id') - b.get('id'))
                      .filter((item) => item && item.get('type') === 'google' && item.get('verified_at'))
                      .map((item) => (
                        <tr key={item.get('id')}>
                          <td />
                          <td>
                            <div>{item.get('name') || 'no name'}</div>
                            <small>
                              (created
                              {' '}
                              <Moment fromNow withTitle utc>
                                {item.get('created_at')}
                              </Moment>
                              )
                            </small>
                          </td>
                          <td>
                            <Button
                              outline
                              onClick={this.onRenameClick(item.get('id'))}
                            >
                              Rename
                            </Button>
                            <Button
                              outline
                              onClick={this.onDeleteClick(item.get('id'))}
                            >
                              Delete
                            </Button>
                          </td>
                        </tr>
                      ))
                      .toArray()}
                  </tbody>
                </table>
              </div>

              <Subheader
                buttons={(
                  <Button onClick={this.onGoogleHotpClick} outline>
                    Activate
                  </Button>
            )}
              >
                <FormattedMessage
                  id="security.2fa.google_count"
                  description="Sub header text for Google Authenticator"
                  defaultMessage="Google Authenticator - HMAC-Based One-time Tokens (HOTP)"
                />
              </Subheader>
              <div className={settingStyles.panel}>
                <Loader loading={loading && list.size === 0} />
                <table className={connectionStyles.connections}>
                  <tbody>
                    {list
                      .sort((a, b) => a.get('id') - b.get('id'))
                      .filter((item) => item && item.get('type') === 'google_count' && item.get('verified_at'))
                      .map((item) => (
                        <tr key={item.get('id')}>
                          <td />
                          <td>
                            <div>{item.get('name') || 'no name'}</div>
                            <small>
                              (created
                              {' '}
                              <Moment fromNow withTitle utc>
                                {item.get('created_at')}
                              </Moment>
                              )
                            </small>
                          </td>
                          <td>
                            <i className="far fa-history" />
                            {' '}
                            {item.getIn(['config', 'count'])}
                            {' '}

                            <Button
                              outline
                              onClick={this.onRenameClick(item.get('id'))}
                            >
                              Rename
                            </Button>
                            <Button
                              outline
                              onClick={this.onDeleteClick(item.get('id'))}
                            >
                              Delete
                            </Button>
                          </td>
                        </tr>
                      ))
                      .toArray()}
                  </tbody>
                </table>
              </div>

              <Subheader
                buttons={(
                  <Button onClick={this.onYubikeyClick} outline>
                    Add
                  </Button>
            )}
              >
                <FormattedMessage
                  id="security.2fa.yubikey"
                  description="Sub header text for Yibikey"
                  defaultMessage="Yubikey"
                />
              </Subheader>
              <div className={settingStyles.panel}>
                <Loader loading={loading && list.size === 0} />
                <table className={connectionStyles.connections}>
                  <tbody>
                    {list
                      .sort((a, b) => a.get('id') - b.get('id'))
                      .filter((item) => item && item.get('type') === 'yubikey' && item.get('verified_at'))
                      .map((item) => (
                        <tr key={item.get('id')}>
                          <td />
                          <td>
                            <div>{item.get('name') || 'no name'}</div>
                            <small>
                              (created
                              {' '}
                              <Moment fromNow withTitle utc>
                                {item.get('created_at')}
                              </Moment>
                              )
                            </small>
                          </td>
                          <td>
                            <Button
                              outline
                              onClick={this.onRenameClick(item.get('id'))}
                            >
                              Rename
                            </Button>
                            <Button
                              outline
                              onClick={this.onDeleteClick(item.get('id'))}
                            >
                              Delete
                            </Button>
                          </td>
                        </tr>
                      ))
                      .toArray()}
                  </tbody>
                </table>
              </div>

              <Subheader
                buttons={(
                  <Button disabled outline>
                    Not available yet
                  </Button>
            )}
              >
                <FormattedMessage
                  id="security.2fa.u2f"
                  description="Sub header text for 2nd Factor (U2F)"
                  defaultMessage="Universal 2nd Factor (U2F)"
                />
              </Subheader>
              <div className={settingStyles.panel}>
                <table className={connectionStyles.connections}>
                  <tbody />
                </table>
              </div>
            </>
          )}
        </Content>
      </>
    );
  }
}

Security.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    list: state.getIn(['mfa', 'list']),
    loading: state.getIn(['mfa', 'loading']),
    error: state.getIn(['mfa', 'error']),
  };
}

export default injectIntl(connect(mapStateToProps)(absolute(Security)));
